// src/types/Sixes.ts

import type { EntityState } from '@reduxjs/toolkit';

import type { CatalogFilterKey, CatalogSortField, CatalogSortDirection } from './SixCatalogDTOs';
import type { ViewMode } from './SixCatalog.types';

export type { CatalogFilterKey } from './SixCatalogDTOs';

/**
 * Owner info (FE model)
 */
export interface Owner {
  id: string;
  name: string;
}

/**
 * Status of a SIX
 */
export const PENDING_HAP_STATUS = 'PendingHAP';

export type SixStatus = 'Active' | 'Inactive' | 'Archived' | typeof PENDING_HAP_STATUS;

/**
 * SIX summary for catalog display (FE model)
 */
export interface SixCatalogItem {
  id: string;
  name: string;
  description: string;
  status: SixStatus;
  isFavorite: boolean;
  isRecent: boolean;
  isMySix: boolean;
  ownerCount: number;
  owners: Owner[];
  participantCount: number;
  fileCount: number;
  swarmKey: string;
  bootstrapNodes: string[];
  createdAt: Date;
  lastModified: Date;
  lastAccessed: Date;
}

/**
 * Pagination info (FE model)
 */
export interface Pagination {
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

/**
 * Catalog state for Redux
 */
export interface CatalogState extends EntityState<SixCatalogItem, string> {
  loading: boolean;
  hasLoaded: boolean;
  error?: string;
  search?: string;
  filters: CatalogFilterKey[];
  pagination?: Pagination;
  sortField: CatalogSortField;
  sortDirection: CatalogSortDirection;
  viewMode: ViewMode;
}
